import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { TRUSTED_SCRIPT_DOMAINS } from '../utils/tinymce';

// Build a strict CSP for the read-only viewer – NO unsafe-eval
// Scripts stay locked to CDN whitelist; iframes allow any https: so all
// educational embeds (Padlet, Kahoot, etc.) render without CSP errors.
const viewerScriptSrc = TRUSTED_SCRIPT_DOMAINS.join(' ');
const viewerCSP = [
  "default-src 'self'",
  `script-src 'self' 'unsafe-inline' ${viewerScriptSrc}`, // no unsafe-eval
  `style-src 'self' 'unsafe-inline' https://fonts.googleapis.com ${viewerScriptSrc}`,
  "img-src 'self' data: blob: https:",
  "media-src 'self' blob: https:",
  "frame-src 'self' https:",
  "font-src 'self' data: https://fonts.gstatic.com https:",
  `connect-src 'self' ${viewerScriptSrc}`,
  "object-src 'none'",
  "base-uri 'self'",
  "form-action 'none'", // prevent form submissions from embedded content
].join('; ');

export default function ViewerEditor({
  initialValue,
  min_height = 400,
  max_height = 900,
}) {
  return (
    <div className="mt-2">
      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        licenseKey="gpl"
        initialValue={initialValue}
        init={{
          plugins: 'link image table tinycomments autoresize',
          toolbar: 'showcomments',
          menubar: false,
          readonly: true,
          editable_root: false,
          autoresize_bottom_margin: 10,
          autoresize_overflow_padding: 10,
          min_height,
          max_height,
          // Allow script/style/iframe tags so saved content renders correctly
          extended_valid_elements:
            'script[src|async|defer|type|charset|crossorigin|integrity|nomodule|referrerpolicy|nonce|id|class],' +
            'style[media|type|scoped|id|class],' +
            'iframe[src|srcdoc|width|height|frameborder|allowfullscreen|sandbox|allow|style|class|id|name|loading|title]',
          valid_children: '+body[script|style],+div[script|style]',
          // Block javascript: URLs in viewer – students should never hit these
          allow_script_urls: false,
          // Do NOT sandbox iframes — embedded apps (Padlet, Kahoot, etc.) need
          // their own scripts to run. CSP frame-src + same-origin policy provide
          // the real security boundary.
          sandbox_iframes: false,
          convert_unsafe_embeds: false,
          // Strict CSP – no eval, no untrusted origins
          content_security_policy: viewerCSP,
          content_style:
            'body { font-family:Helvetica,Arial,sans-serif; font-size:14px } ' +
            'img { max-width: 100%; border-radius: 5px; } ' +
            'img:not([height]) { height: auto; }',
        }}
      />
    </div>
  );
}
